import { APIMethod, fetchData } from "@client";
import { getCurrency } from "@repo/utils";

export async function getCurrentSubscriptionQuery() {
  try {
    const res = await fetchData("/v2/company/subscription", APIMethod.GET);

    if (res && !res.length && res.subscriptionId) {
      const {
        planName,
        status,
        currency,
        billingInterval,
        estimates,
        users,
        priceAmount,
        discount,
        trialTo,
        isTrialing,
        defaultPaymentMethod,
        periodStart,
        periodEnd,
        nextPayment,
      } = res;

      let discountPrice;
      if (discount?.valid) {
        if (discount.amountOff)
          discountPrice = priceAmount - discount.amountOff / 100;
        if (discount.percentOff)
          discountPrice = (priceAmount - (priceAmount * discount.percentOff)) / 100;
          // discountPrice = priceAmount * discount.percentOff / 100;
      }

      return {
        status,
        currency: getCurrency(currency.toUpperCase()),
        name: planName?.match(/^\d+ Estimates - (.*) [YM]$/)?.[1] || planName,
        price: priceAmount,
        discountPrice,
        duration: billingInterval,
        estimates,
        users,
        isTrialing,
        defaultPaymentMethod,
        trialTo: trialTo ? trialTo * 1000 : undefined,
        from: periodStart * 1000,
        to: nextPayment ? nextPayment * 1000 : undefined,
        subscriptionEnds: !nextPayment && periodEnd ? periodEnd * 1000 : undefined,
      };
    }
    return null;
  } catch (e) {
    return null;
  }
}
